var _path, _path2, _g, _path3, _path4, _path5, _g2, _path6, _path7, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingLogoStay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 22,
    viewBox: "0 0 117 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2291_5481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 117,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000128431H117V21.8267H0V0.000128431Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2291_5481)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2291_5481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 117,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.8267H117V0.000128431H0V21.8267Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2291_5481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8809 2.38892C45.8809 1.87051 46.0682 1.37334 46.4016 1.00677C46.735 0.640198 47.1873 0.434261 47.6588 0.434261C48.1303 0.434261 48.5825 0.640198 48.9159 1.00677C49.2494 1.37334 49.4367 1.87051 49.4367 2.38892C49.4195 2.8947 49.2247 3.37348 48.8931 3.72463C48.5616 4.07578 48.1192 4.27197 47.6588 4.27197C47.1984 4.27197 46.756 4.07578 46.4244 3.72463C46.0929 3.37348 45.898 2.8947 45.8809 2.38892Z",
    fill: "#273B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9326 15.4247C73.9326 14.3398 74.7275 13.4646 75.7068 13.4646C76.0598 13.4627 76.4053 13.5761 76.6996 13.7903C76.9939 14.0045 77.2238 14.31 77.36 14.668C77.4963 15.026 77.5329 15.4204 77.4651 15.8012C77.3973 16.1821 77.2282 16.5322 76.9792 16.8073C76.7302 17.0824 76.4126 17.27 76.0665 17.3464C75.7204 17.4228 75.3615 17.3845 75.0352 17.2365C74.7089 17.0884 74.43 16.8372 74.2337 16.5146C74.0374 16.1921 73.9326 15.8128 73.9326 15.4247Z",
    fill: "#499FDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.714 14.5768C15.1838 14.5768 14.119 13.2402 14.119 11.3291C14.119 9.41796 15.1837 8.084 16.7153 8.084C18.2542 8.084 19.3301 9.41796 19.3301 11.3291C19.3301 13.2701 18.2778 14.5768 16.714 14.5768ZM16.714 5.2296C13.4752 5.2296 11.124 7.79543 11.124 11.3277C11.124 14.86 13.4764 17.4258 16.714 17.4258C19.9665 17.4258 22.3264 14.8613 22.3264 11.3277C22.3264 7.79407 19.9665 5.22688 16.7153 5.22688M42.4491 11.6326C42.3364 11.3929 42.1938 11.1716 42.0256 10.9751L41.9266 10.8622L42.0306 10.7533C42.194 10.5627 42.343 10.3578 42.4763 10.1407L45.3239 5.46917H41.8523L39.7042 9.12394C39.5829 9.31995 39.3378 9.41796 38.9701 9.41796H38.481V2.5086C38.481 1.127 37.6973 0.939162 36.8517 0.939162H35.4031L35.4068 17.2461H38.4822V12.354H38.7707C39.1211 12.354 39.3588 12.3989 39.469 12.6086L41.1652 16.1286C41.6394 17.0841 42.1111 17.2447 43.0001 17.2447H45.3561L43.6005 14.0541L42.4367 11.6312M57.3644 5.1983C55.7995 5.1983 54.8015 5.96328 54.2419 6.60984L54.0562 6.81674L53.9894 6.53498C53.8259 5.84077 53.2713 5.46237 52.438 5.46237H51.0601L51.0687 17.2407H54.1231V11.8123C54.1231 11.2814 54.185 10.8213 54.3138 10.4007C54.653 9.12802 55.6014 8.33718 56.7863 8.33718C57.7396 8.33718 58.111 8.89118 58.111 10.3204V15.4521C58.111 16.6717 58.6248 17.242 59.7354 17.242H61.1889L61.184 9.75008C61.184 6.77454 59.8629 5.20102 57.3631 5.20102M47.706 5.46781H46.2575L46.2674 17.2461H47.8113L47.8658 17.2488L48.5863 17.2461H49.3019V17.242H49.3069L49.3131 7.25776C49.3131 6.05312 48.7894 5.46781 47.706 5.46781ZM28.7075 14.5755C27.1772 14.5755 26.1112 13.2388 26.1112 11.3277C26.1112 9.41659 27.1759 8.08264 28.7087 8.08264C30.2415 8.08264 31.3236 9.41659 31.3236 11.3277C31.3236 13.2687 30.27 14.5755 28.7075 14.5755ZM28.7075 5.22824C25.4662 5.22824 23.1138 7.79407 23.1138 11.3263C23.1138 14.8586 25.4662 17.4244 28.71 17.4244C31.9538 17.4244 34.3222 14.86 34.3222 11.3263C34.3222 7.79271 31.9699 5.22552 28.71 5.22552",
    fill: "#273B7D"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2291_5481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 117,
    height: 22
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000128431H117V21.8267H0V0.000128431Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2291_5481)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2291_5481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 117,
    height: 22
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.430522H116.975V21.7983H0V0.430522Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2291_5481)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2291_5481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 117,
    height: 22
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.8267H117V0.000128431H0V21.8267Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2291_5481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1627 14.5768C92.6325 14.5768 91.5652 13.2401 91.5652 11.3291C91.5652 9.41795 92.6325 8.084 94.1627 8.084C95.7005 8.084 96.7789 9.41795 96.7789 11.3291C96.7789 13.2701 95.7265 14.5768 94.1627 14.5768ZM94.1627 5.2296C90.9214 5.2296 88.5703 7.79543 88.5703 11.3277C88.5703 14.86 90.9227 17.4258 94.1627 17.4258C97.4115 17.4258 99.7751 14.8613 99.7751 11.3277C99.7751 7.79407 97.4227 5.22688 94.1627 5.22688",
    fill: "#499FDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6266 14.0582C65.9552 14.0582 65.3609 12.4574 65.3609 10.9547C65.3609 10.2932 65.5132 8.13706 67.4657 8.13706C68.4351 8.13706 69.7264 8.44196 69.7264 11.0636C69.7264 13.5369 68.5836 14.0555 67.6253 14.0555L67.6266 14.0582ZM71.3136 5.4392C70.7342 5.4392 70.2885 5.69374 70.0755 6.1579L69.9914 6.33758L69.8503 6.20146C69.3575 5.73321 68.4735 5.17649 67.0398 5.17649C64.1835 5.17649 62.2607 7.53542 62.2607 11.0432C62.2607 14.5509 64.2503 16.9997 67.0967 16.9997C68.0686 16.9997 68.8374 16.7492 69.4466 16.2429L69.6942 16.0482V16.3749C69.6942 17.9484 68.7694 18.8169 67.0918 18.8169C66.3901 18.8076 65.6951 18.6668 65.0366 18.4004C64.3903 18.1853 64.0089 18.3636 63.7489 19.0782L63.5062 19.737L63.1633 20.7008L63.3738 20.8233C64.4484 21.4494 65.8462 21.8237 67.1091 21.8237C69.7091 21.8237 72.7474 20.3605 72.7474 16.2429L72.7598 5.4392H71.3136Z",
    fill: "#273B7D"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2291_5481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 117,
    height: 22
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000128431H117V21.8267H0V0.000128431Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2291_5481)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2291_5481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 117,
    height: 22
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.8267H117V0.000128431H0V21.8267Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2291_5481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.32976 14.4418L2.84367 14.4391V11.1723C2.84367 10.4726 3.09129 10.1105 3.63357 10.0261H5.32976C6.53938 10.0261 7.31076 10.8646 7.31076 12.2217C7.30952 13.6156 6.54681 14.4405 5.32976 14.4405V14.4418ZM2.84367 5.62681V4.76655C2.84367 4.01381 3.13339 3.65582 3.76854 3.60954H5.04132C6.13084 3.60954 6.77461 4.32689 6.77461 5.52881C6.77461 6.44352 6.3264 7.51205 5.06973 7.51205H2.83256L2.84367 5.62681ZM8.50427 8.8882L8.05479 8.61052L8.44729 8.243C8.90538 7.81151 9.66808 6.84099 9.66808 5.16673C9.66808 2.60227 7.86042 0.947075 5.06233 0.947075H1.50409C1.1037 0.963124 0.72423 1.14792 0.444406 1.46316C0.164582 1.77841 0.00579816 2.19993 0.000976562 2.64038V17.1914H5.12671C8.23804 17.1914 10.2462 15.3293 10.2462 12.445C10.2462 10.8932 9.59745 9.56471 8.50668 8.88956",
    fill: "#273B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.418 5.2434C112.787 5.24595 112.165 5.40421 111.598 5.70649C111.03 6.00876 110.532 6.44733 110.139 6.98979L109.919 7.29742L109.746 6.95304C109.179 5.81918 108.206 5.2434 106.852 5.2434C105.432 5.2434 104.48 6.11455 104.038 6.6318L103.748 6.97618L103.625 6.52291C103.464 5.86954 102.935 5.51155 102.135 5.51155H100.851L100.839 17.2449H103.755V12.0656C103.756 11.6031 103.808 11.1425 103.909 10.6936C104.188 9.44128 104.953 8.09371 106.239 8.22983C107.032 8.31422 107.421 8.98801 107.421 10.2893V17.2449H110.357V12.0656C110.346 11.5868 110.402 11.109 110.522 10.6486C110.77 9.45353 111.557 8.22847 112.798 8.22847C113.696 8.22847 114.028 8.78655 114.028 10.2893V15.5298C114.028 16.7141 114.509 17.2449 115.588 17.2449H116.96L116.963 9.75435C116.963 6.75975 115.764 5.2434 113.407 5.2434M86.8694 13.1709C86.8607 13.1845 85.6066 14.6369 83.9537 14.6369C82.4482 14.6369 80.9278 13.6215 80.9278 11.3565C80.9278 9.39908 82.1065 8.0311 83.7953 8.0311C84.3425 8.0311 84.9665 8.24616 85.0643 8.6096L85.0767 8.67085C85.1391 8.92106 85.2748 9.14165 85.4628 9.29841C85.6508 9.45518 85.8807 9.53937 86.1167 9.53792L87.7262 9.54065V8.00523C87.7262 5.9798 85.3825 5.24476 83.8064 5.24476C80.4338 5.24476 77.9873 7.82556 77.9873 11.381C77.9873 14.9364 80.4066 17.5117 83.7445 17.5117C86.6391 17.5117 88.2016 15.4196 88.2289 15.3992L88.3131 15.2848L87.0477 12.9776L86.8805 13.1723",
    fill: "#499FDD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingLogoStay);
export default __webpack_public_path__ + "static/media/bookingLogoStay.d92704d87afb54e68fed17b6a19092b4.svg";
export { ForwardRef as ReactComponent };